import { defineStore } from 'pinia';
import { ref } from 'vue';
import { Theme } from '@/types/ui';

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<Theme>(localStorage.getItem('theme') as Theme ?? 'dark');

  const setTheme = (value: Theme) => {
    theme.value = value;
    localStorage.setItem('theme', value);
  };

  return {
    theme,
    setTheme,
  }
});
